import React, { useState } from 'react';
import { motion } from 'framer-motion';
type TripType = 'one-way' | 'round-trip' | 'multi-leg' | 'empty-legs';
const tabs: {
  id: TripType;
  label: string;
}[] = [{
  id: 'one-way',
  label: 'One-way'
}, {
  id: 'round-trip',
  label: 'Round trip'
}, {
  id: 'multi-leg',
  label: 'Multi-leg'
}, {
  id: 'empty-legs',
  label: 'Empty legs'
}];
type FieldProps = {
  label: string;
  type?: string;
  placeholder?: string;
};
function Field({
  label,
  type = 'text',
  placeholder
}: FieldProps) {
  const id = label.replace(/\s+/g, '-').toLowerCase();
  return <fieldset className="group relative rounded-xl border border-gray-300 px-4 pb-3 pt-2 transition-colors focus-within:border-brand-500 hover:border-gray-400" data-id="element-80">
      <legend className="px-1.5 text-sm text-gray-500 transition-colors group-focus-within:text-brand-600" data-id="element-81">
        {label}
      </legend>
      <input id={id} type={type} placeholder={placeholder} className="w-full bg-transparent text-base text-charcoal-900 outline-none placeholder:text-gray-300" data-id="element-82" />
    </fieldset>;
}
export function FlightSearch() {
  const [tripType, setTripType] = useState<TripType>('one-way');
  return <div className="w-full max-w-5xl mx-auto bg-white/95 backdrop-blur-xl rounded-2xl shadow-glass border border-white/20 p-6 md:p-8" data-id="element-83">
      {/* Tabs */}
      <div className="flex items-center gap-6 sm:gap-10 overflow-x-auto hide-scrollbar mb-7" data-id="element-84">
        {tabs.map(tab => <button key={tab.id} onClick={() => setTripType(tab.id)} className={`relative whitespace-nowrap pb-3 text-lg font-medium transition-colors ${tripType === tab.id ? 'text-brand-600' : 'text-charcoal-700 hover:text-charcoal-900'}`} data-id="element-85">
            {tab.label}
            {tripType === tab.id && <motion.div layoutId="flightSearchTab" className="absolute -bottom-px left-0 right-0 h-0.5 rounded-full bg-brand-500" data-id="element-86" />}
          </button>)}
      </div>

      {/* Fields */}
      <div className="flex flex-col lg:flex-row lg:items-stretch gap-4" data-id="element-87">
        <div className="flex-1" data-id="element-88">
          <Field label="Leaving from" placeholder="City or airport" data-id="element-89" />
        </div>
        <div className="flex-1" data-id="element-90">
          <Field label="Going to" placeholder="City or airport" data-id="element-91" />
        </div>
        <div className="w-full lg:w-52" data-id="element-92">
          <Field label="Date" type="date" data-id="element-93" />
        </div>

        <button className="shrink-0 self-stretch rounded-full bg-brand-500 px-10 py-4 text-base font-semibold text-white transition-colors hover:bg-brand-600 lg:py-0" data-id="element-94">
          Search
        </button>
      </div>
    </div>;
}